module.exports = __webpack_public_path__ + "static/img/rank_71.0c113b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_71.png
// module id = NuUo
// module chunks = 1